"use client";

import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";
import { ApiPage } from "@/api/page";

export const useLegalNoticeData = () => {
  const { data, isLoading } = useLocalizedQuery({
    queryKey: ["legal-notice"],
    queryFn: async lang => ApiPage.getLegalNoticePage(lang),
  });

  return { data, isLoading };
};
